import { EnumSchema } from '../metadata-schema';

export const Uitstroommoment: EnumSchema = {
	"type": "string",
	"title": "Uitstroommoment",
	"enum": [
		"Einde schooljaar",
		"Tussentijds"
	]
};
